import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const newURL = this.props.location.pathname + this.props.location.search;
    const prevURL = prevProps.location.pathname + prevProps.location.search;
    if (newURL !== prevURL) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.shape([PropTypes.object]).isRequired,
  children: PropTypes.node.isRequired
};

export default withRouter(ScrollToTop);
